import MoreHorizOutlinedIcon from "@mui/icons-material/MoreHorizOutlined";
import { IconButton } from "@mui/material";
import React from "react";
import TemplateActions from "./TemplateActions";
import type { ClientInfoExtended, ReportConfiguration, ReportTemplate } from "../../../../../../api/types/svTypes.ts";

interface Props {
  template: ReportTemplate;
  getTemplateConfigurationAsync: () => Promise<ReportConfiguration | undefined>;
  companies: ClientInfoExtended[];
  onEdited: (template: ReportTemplate, dataSourceChanged?: boolean) => void;
  onDataSourceChanged: (ds: string) => void;
}

export default function MoreAction(props: Props) {
  const { template, onEdited, getTemplateConfigurationAsync, onDataSourceChanged, companies } = props;
  const [openActionsMenu, setOpenActionsMenu] = React.useState(false);
  const [actionMenuRef, setActionMenuRef] = React.useState<HTMLElement | null>(null);

  return (
    <>
      <IconButton key="actionButton" ref={setActionMenuRef} onClick={() => setOpenActionsMenu(true)}>
        <MoreHorizOutlinedIcon sx={(theme) => ({ color: theme.palette.secondary.light })} />
      </IconButton>
      {openActionsMenu && (
        <TemplateActions
          key={"actions"}
          anchorEl={actionMenuRef}
          template={template}
          getTemplateConfigurationAsync={getTemplateConfigurationAsync}
          onClose={() => setOpenActionsMenu(false)}
          onEdited={onEdited}
          onDataSourceChanged={onDataSourceChanged}
          companies={companies}
        />
      )}
    </>
  );
}
